import React from 'react';

import ResultView from './Result.view';
import ResultContainer from './Result.container';

const Result = ({ onEndQuiz }) => {
  return (
    <ResultContainer>
      {({
        score,
        fullScore,
        round,
        averageScore,
        onSeeSolution,
        onSeeMoreScore,
        onDoQuizAgain,
        title,
        isLastAttempt,
        isQuizStarting,
      }) => {
        return (
          <ResultView
            score={score}
            fullScore={fullScore}
            onSeeMoreScore={onSeeMoreScore}
            onSeeSolution={onSeeSolution}
            onGoToNextSubsection={onEndQuiz}
            onDoQuizAgain={onDoQuizAgain}
            round={round}
            averageScore={`${averageScore} คะแนน`}
            quizTitle={title}
            disableDoQuizAgainButton={isLastAttempt || isQuizStarting}
          />
        );
      }}
    </ResultContainer>
  );
};

export default Result;
